export function playAudio (audioSrc = null) {
  const audioPlayer = new Audio(audioSrc) //eslint-disable-line

  audioPlayer.onerror = () => {
    throw new Error('Erro ao criar instância de áudio, caminho de áudio não encontrado: ' + audioSrc)
  }
  audioPlayer.play()
}
